import type { Integration } from '@sentry/core';

/**
 * Помогает Sentry создавать правильные паттерны для транзакций.
 * По-умолчанию Sentry не всегда понимает, что какой-то сегмент пути у нас динамический.
 */
export function transactionPatternIntegration(): Integration {
  return {
    name: 'TransactionPatternIntegration',
    processEvent: (event) => {
      if (event.transaction && event.type === 'transaction') {
        event.transaction = event.transaction
          .replace(/^\/my\/[^\/]+/, '/my/:account_nick')
          .replace(/\/view\/vacancy\/\d+/, '/view/vacancy/:vacancy_id');
      }
      return event;
    }
  };
}
